<div class="create-claims-container">
  <dxo-card [bodyHeader]="claimsBodyHeader">
    <card-body>
      <div class="sub-header" data-e2e="claims-sub-header">{{ claimsBodySubHeader }}</div>
      <div class="body-container" data-e2e="claims-body">
        <div *ngFor="let item of claimsBody">{{ item }}</div>
      </div>
    </card-body>
    <dxo-button text="Get claim packet" [primary]="true" (handleClick)="goFormsClaimPage()" data-e2e="claims-button">
    </dxo-button>
  </dxo-card>
</div>
